/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DatepicherComponent } from '../menu-filters/datepicher/datepicher.component';
import { RoutingService } from '../../../service/routing.service';
import { Location } from '@angular/common';
import { UntypedFormControl } from '@angular/forms';
import { AuthService } from 'src/app/service/auth.service';
import { ConfigService } from 'src/app/service/config.service';
import { BreakpointService } from 'src/app/shared/services/breakpoints.service';

/**
 * main menu filter of the application
 */
@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-menu-options',
  templateUrl: './menu-options.component.html',
  styleUrls: ['./menu-options.component.scss'],
})
export class MenuOptionsComponent implements AfterViewInit {
  /**
   * sort by
   */
  sort: any;

  /**
   * time
   */
  time: any;

  /**
   * filtering by sentiment (possible values: 'pos', 'neu', 'neg')
   */
  filter: any;

  /**
   * possible values and labels for filtering by sentiment options
   */
  filterLabels = {
    pos: 'Pos',
    neu: 'Neu',
    neg: 'Neg',
    all: 'All',
  };

  /**
   * filter by sentiment name to display
   */
  filterName: string;

  /**
   * array of the time
   */
  timenumber: any = ['0', '1', '7', '30', '90', '365'];

  /**
   * time array string
   */
  timestring: any = ['custom', 'day', 'week', 'month', 'quarter', 'year'];

  /**
   * time name to display
   */
  timename: string;

  /**
   * feed selected
   */
  feed: any;

  /**
   *
   */
  params: any;

  /**
   *
   */
  layout = 'main';

  /**
   *
   */
  intheme = true;

  /**
   * possible labels and values of language filters
   */
  filterLang = [
    {
      label: 'English',
      value: 'en',
    },
    {
      label: 'German',
      value: 'de',
    },
  ];
  menuButtonLang = [];

  /**
   * possible labels and values of timeframe filters
   */
  filterTimeframe = [
    {
      label: 'Day',
      value: '1',
    },
    {
      label: 'Week',
      value: '7',
    },
    {
      label: 'Month',
      value: '30',
    },
    {
      label: 'Quarter',
      value: '90',
    },
    {
      label: 'Custom',
      value: '0',
    },
  ];
  /**
   * form control for timeframe filters
   */
  menuFilterTimeframe: UntypedFormControl;

  /**
   * possible labels and values of sentiment filters
   */
  filterSentiment = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Positive',
      value: 'pos',
    },
    {
      label: 'Neutral',
      value: 'neu',
    },
    {
      label: 'Negative',
      value: 'neg',
    },
  ];
  /**
   * form control for sentiment filters
   */
  menuFilterSentiment: UntypedFormControl;

  /**
   * form control for language filters
   */
  menuFilterLang: UntypedFormControl;

  /**
   *
   */
  project: string;

  /**
   *
   */
  i18n = 'English';

  /**
   * period
   */
  period: string;

  /**
   *
   */
  filterNews = [
    {
      label: 'Pro (Full Text)',
      value: 'professional',
      icon: 'star',
      active: true,
    },
    {
      label: 'Print (Full Text)',
      value: 'print',
      icon: 'list_alt',
      active: true,
    },
    {
      label: 'Web (Finance)',
      value: 'online',
      icon: 'dvr',
      active: true,
    },
    {
      label: 'Web (Global)',
      value: 'non_professional',
      icon: 'rss_feed',
      active: true,
    },
  ];
  menuButtonNews = [];

  /**
   * form control of the feed
   */
  menuFilterNews: UntypedFormControl;

  /**
   * events object containing info for filtering purposes
   */
  events: any;

  /**
   * events filter
   */
  filterEvents = [];

  /**
   * form control of the events filter
   */
  menuFilterEvents: UntypedFormControl;

  /**
   * Observable that emits the current screen size.
   * This observable is provided by the BreakpointService and can be used to
   * reactively respond to changes in the screen size.
   */
  screenSize$ = this.breakpointService.screenSize$;

  /**
   * query parameters subscribe and initialize the formcontrols
   */
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public routing: RoutingService,
    public location: Location,
    public auth: AuthService,
    public config: ConfigService,
    private cd: ChangeDetectorRef,
    private breakpointService: BreakpointService,
  ) {
    this.project = this.config.appConfig.routing.project;
    if (this.config.appConfig.routing.project === 'ubs') {
      this.intheme = false;
    }
    this.route.queryParams.subscribe((params) => {
      if (params.event_ids) {
        this.menuFilterEvents = new UntypedFormControl(
          params.event_ids.split(','),
        );
      } else {
        this.menuFilterEvents = new UntypedFormControl();
      }

      this.period = params.period ? params.period : '7';
      if (params.filter) {
        this.menuFilterSentiment = new UntypedFormControl(
          params.filter.split(','),
        );
      } else {
        this.menuFilterSentiment = new UntypedFormControl(['all']);
      }
      if (params.lang) {
        this.menuFilterLang = new UntypedFormControl(params.lang.split(','));
        this.menuButtonLang = this.filterLang.filter(
          (option) => params.lang.split(',').indexOf(option.value) !== -1,
        );
      } else {
        this.menuFilterLang = new UntypedFormControl(
          this.filterLang.map((option) => option.value),
        );
        this.menuButtonLang = this.filterLang.filter(
          (option) => this.menuFilterLang.value.indexOf(option.value) !== -1,
        );
      }
      if (params.feed) {
        this.menuFilterNews = new UntypedFormControl(params.feed.split(','));
        this.menuButtonNews = this.filterNews.filter(
          (option) => params.feed.split(',').indexOf(option.value) !== -1,
        );
      } else {
        this.menuFilterNews = new UntypedFormControl(
          this.filterNews.map((option) => {
            if (option.active) {
              return option.value;
            }
          }),
        );
        this.menuButtonNews = this.filterNews.filter(
          (option) => this.menuFilterNews.value.indexOf(option.value) !== -1,
        );
      }
      this.params = params;
      this.feed = params.feed || 'all';
      this.filter = params.filter ? params.filter : 'all';
      this.filterName = this.filterLabels[this.filter];
      if (params.time) {
        this.time = params.time;
        if (
          params.time === '1' ||
          params.time === '7' ||
          params.time === '14' ||
          params.time === '30' ||
          params.time === '90'
        ) {
          this.menuFilterTimeframe = new UntypedFormControl(
            params.time.split(','),
          );
        } else {
          this.menuFilterTimeframe = new UntypedFormControl(['0']);
        }
      } else {
        this.time = '7';
        this.menuFilterTimeframe = new UntypedFormControl(['7']);
      }
      this.timename = this.timestring[this.timenumber.indexOf(this.time)];
      if (this.timename === 'custom') {
        this.timename = params.time;
      }
    });
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  /**
   * parse the time
   */
  goTime(value) {
    let period = value;
    if (value === 30) {
      period = 7;
    }
    if (value === 90) {
      period = 14;
    }
    this.router.navigate([], {
      queryParams: {
        time: value,
        period: period,
        tag: null,
        newsday: null,
      },
      queryParamsHandling: 'merge',
      replaceUrl: false,
    });
  }

  /**
   * open dialog datepicher
   */
  goCustom() {
    let time = this.time;
    if (this.time === '0') {
      time = this.params.time;
    }
    const dialogRef = this.dialog.open(DatepicherComponent, {
      data: {
        time: time,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (
        result &&
        Object.prototype.hasOwnProperty.call(result, 'time') &&
        Object.prototype.hasOwnProperty.call(result, 'period')
      ) {
        this.time = result.time;
        this.period = result.period;
      } else {
        if (this.params.time) {
          if (this.params.time < 500) {
            this.menuFilterTimeframe = new UntypedFormControl(
              this.params.time.split(','),
            );
          } else {
            this.menuFilterTimeframe = new UntypedFormControl(['0']);
          }
        } else {
          this.menuFilterTimeframe = new UntypedFormControl(['7']);
        }
      }
    });
  }

  /**
   * change the feed type
   */
  goFeed(value) {
    this.router.navigate([], {
      queryParams: {
        feed: value,
        newsday: null,
      },
      queryParamsHandling: 'merge' /*, replaceUrl: true*/,
    });
  }

  /**
   * change sort by
   */
  goSortBy(value) {
    this.router.navigate([], {
      queryParams: {
        sort: value,
      },
      queryParamsHandling: 'merge' /*, replaceUrl: true*/,
    });
  }

  /**
   * change the theme
   */
  inTheme(theme) {
    // localStorage.set('theme', theme)
    this.router.navigate([], {
      queryParams: {
        theme: theme,
      },
      queryParamsHandling: 'merge' /*, replaceUrl: true*/,
    });
    // this.routing.inTheme(theme)
  }

  /**
   * change filtering by sentiment
   */
  goSentiment(sentiment) {
    this.router.navigate([], {
      queryParams: {
        filter: sentiment !== 'all' ? sentiment : null,
      },
      queryParamsHandling: 'merge' /*, replaceUrl: true*/,
    });
  }

  /**
   * change the language
   */
  inLang(event) {
    this.router.navigate([], {
      queryParams: {
        lang: event !== 'multi' ? event : null,
      },
      queryParamsHandling: 'merge' /*, replaceUrl: true*/,
    });
  }

  /**
   * check/uncheck radio button based on filter
   * @param filter
   */
  isFilter(filter) {
    if (this.filter === filter) {
      return 'radio_button_checked';
    }
    return 'radio_button_unchecked';
  }
}
